import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import SubscribeButton from '../../../../Button/SubscribeButton';
import TierPricePerMonth from '../../../Helper/TierPricePerMonth';

import s from './PriceAndSubscribeButton.scss';

export interface Props {
  tier: PapiDeviation;
  className?: string;
}

/** Price/month and subscribe button */
const PriceAndSubscribeButton: React.FC<Props> = ({ tier, className }) => {
  return (
    <div className={classnames(s['root'], className)}>
      {tier.tier?.dollarPrice && (
        <TierPricePerMonth className={s['price']} price={tier!.tier?.dollarPrice} />
      )}
      <SubscribeButton className={s['subscribe-button']} tier={tier} href={tier.url} size="small" />
    </div>
  );
};
PriceAndSubscribeButton.displayName = 'PriceAndSubscribeButton';

export default PriceAndSubscribeButton;
